import React, { useState, useContext } from 'react'
import {
    DateRangeSelector,
    NumberRangeSelector,
    StringInput,
} from '../../../elem/Selectors'
import { FaCaretDown, FaCaretRight } from 'react-icons/fa'
import useKeyPress from '../../../hooks/useKeyPress'
import { FilterContext } from '../../../wrappers/FilterContext'
import calcAttFilters from '../../../../utils/calcAttFilters'

const CriteriaFilter = ({ filters, externalDataItems }) => {
    const [show, setShow] = useState(false)
    const [temp, setTemp] = useState({})
    const { criteria, setCriteria } = useContext(FilterContext)

    const handleClick = () => {
        setCriteria({})
        if (Object.keys(temp).length) {
            setCriteria(calcAttFilters(temp, externalDataItems))
        }
    }

    const handleClear = (e) => {
        setTemp({})
        setCriteria({})
    }

    useKeyPress(temp, 'Enter', () => {
        handleClick()
    })
    return (
        <div className="criteriaFilter">
            <div>
                <h6
                    style={{
                        color: '#d7e7f1',
                        paddingLeft: '.5rem',
                        paddingTop: '1rem',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                    className="is-size-7"
                    onClick={() => setShow(!show)}
                >
                    Additional Filters{' '}
                    {show ? <FaCaretDown /> : <FaCaretRight />}
                </h6>
                <button
                    className={show ? 'button is-small is-inverted' : 'hidden'}
                    style={{ marginLeft: '1%' }}
                    onClick={handleClick}
                >
                    Apply
                </button>
                <button
                    className={show ? 'button is-small is-inverted' : 'hidden'}
                    onClick={handleClear}
                >
                    Remove
                </button>
            </div>
            <div
                className={show ? 'box' : 'hidden'}
                style={{
                    width: 'fit-content',
                    padding: '.15rem',
                    marginTop: '0px',
                }}
            >
                {Object.keys(filters).map((item, i) => (
                    <div className="attributeFilterItem" key={`${item}_${i}`}>
                        <h6 className="is-size-7">{filters[item].Label}: </h6>
                        {filters[item].DataType === 'Date' ? (
                            <DateRangeSelector
                                setCriteria={setTemp}
                                criteria={criteria}
                                label={item}
                            />
                        ) : filters[item].DataType === 'Number' ? (
                            <NumberRangeSelector
                                temp={temp}
                                setTemp={setTemp}
                                item={item}
                            />
                        ) : (
                            <StringInput
                                temp={temp}
                                setTemp={setTemp}
                                item={item}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CriteriaFilter
